// @flow
import React, { useEffect, useState,  } from 'react';
import Box from "@mui/material/Box";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import { useTranslation } from "react-i18next";
import { Grid, Typography, Checkbox, Switch, FormControlLabel, Select, MenuItem} from "@mui/material";
import {LOANS} from "../../../loans/locales/namespaces";
import DynamicFormField from '../../components/form/dynamicForm/dynamicFormField.js';


const PropertySearch = ({ searchFieldsData = [], searchQuestionnaire = [],loanId }) => {
    const { t } = useTranslation(LOANS)
    const [loading, setLoading] = useState(false)
    const [searchFields, setSearchFields] = useState(searchQuestionnaire)
    const [formValues, setFormValues] = useState({
        contactForProperties: false,
        contactPropertiesNumber: 10,
        consentToTransfer: false,
        acceptTerms: false
    });


    const handleChangeCheckboxSwitch = (e) => {        
        const { name, checked } = e.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: checked
        }));
    };

        const handleChangeSelect = (e) => {        
        const { name, value } = e.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: value
        }));
    };



    const options = [
        { value: 1, label: "1 Μεσίτες" },
        { value: 2, label: "2 Μεσίτες" },
        { value: 3, label: "3 Μεσίτες" },
        { value: 4, label: "4 Μεσίτες" },
        { value: 5, label: "5 Μεσίτες" },
        { value: 6, label: "6 Μεσίτες" },
        { value: 7, label: "7 Μεσίτες" },
        { value: 8, label: "8 Μεσίτες" },
        { value: 9, label: "9 Μεσίτες" },
        { value: 10, label: "10 Μεσίτες" },
        { value: 11, label: "11 Μεσίτες" },
        { value: 12, label: "12 Μεσίτες" },
        { value: 13, label: "13 Μεσίτες" },
        { value: 14, label: "14 Μεσίτες" },
        { value: 15, label: "15 Μεσίτες" },
        { value: 16, label: "16 Μεσίτες" },
        { value: 17, label: "17 Μεσίτες" },
        { value: 18, label: "18 Μεσίτες" },
        { value: 19, label: "19 Μεσίτες" },
        { value: 20, label: "20 Μεσίτες" },
    ];


    return (
        <Box>
            <Box className="property-search-form-cnt">
                <Box sx={{ backgroundColor: 'white', border: '0.6px solid #DAE0F0', borderRadius: '12px', minHeight: 'calc(100vh - 300px)' }}>
                    <Box sx={{ padding: {xs: '16px 16px', sm: '16px 16px', md:'24px 24px'} , 'label': { display: 'block', fontSize: '12px', color: '#485476' } }}>
                        <Grid>
                            <Grid item xs={12}>
                                <Typography className='title-sm color-default'>
                                    {t("Find the right property with professional guidance")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className='p-xsfs color-default' sx={{marginTop:'8px'}}>
                                    {t("Fill out the questionnaire and receive proposals from partner agents that match your needs.")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <DynamicFormField 							
                                    formFields={searchFields}
                                />
                            </Grid>


                            <Grid item xs={12} sx={{ marginTop: '24px' }}>
                                <Box className="contact-properties">

                                    <Grid container>
                                        <Grid item xs={12} sm={4}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="contactForProperties"
                                                        checked={formValues.contactForProperties}
                                                        onChange={handleChangeCheckboxSwitch}
                                                    />
                                                }
                                                label={t("I want to be contacted about properties from") + ":"}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <Select
                                                className='contact-select-properties'
                                                id="contact-select"
                                                labelId="contact-select-label"
                                                name={"contactPropertiesNumber"}
                                                value={formValues.contactPropertiesNumber}
                                                onChange={handleChangeSelect}
                                            >
                                                {options.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid>
                                    </Grid>

                                </Box>
                            </Grid>


                            <Grid item xs={12}>
                                <FormControlLabel
                                control={
                                    <Checkbox
                                        name="consentToTransfer"
                                        checked={formValues.consentToTransfer}
                                        onChange={handleChangeCheckboxSwitch}
                                    />
                                }
                                label={t(
                                    "I express my interest and consent to the transfer of the necessary application details to the cooperating real estate agencies."
                                )}
                                />
                            </Grid>


                            <Grid item xs={12}>
                               <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="acceptTerms"
                                            checked={formValues.acceptTerms}
                                            onChange={handleChangeCheckboxSwitch}
                                        />
                                    }
                                    label={t(
                                        "I have read and accept the terms and conditions as well as the privacy policy of IMS FC."
                                    )}
                                />
                            </Grid>



                            <Grid item xs={12}>
                                {t('Clear')}
                            </Grid>
                            <Grid item xs={12}>
                                {t('Save')}
                            </Grid>


                        </Grid>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
};

export default withPermissionHOC(PropertySearch, ['access_loan_details']);
